import type { TfClient } from '../client-internal';
import type { Database } from '../types.gen';

export type Lead = Database['public']['Tables']['tf_leads']['Row'];
export type LeadInsert = Database['public']['Tables']['tf_leads']['Insert'];
export type LeadStatus = Database['public']['Enums']['tf_lead_status'];

export interface LeadFilter {
  toolId?: string;
  status?: LeadStatus;
  sessionId?: string;
  limit?: number;
}

export async function createLead(c: TfClient, input: LeadInsert): Promise<Lead> {
  const { data, error } = await c.from('tf_leads').insert(input).select('*').single();
  if (error) throw error;
  return data;
}

export async function updateLeadStatus(
  c: TfClient,
  id: string,
  status: LeadStatus,
  patch: Partial<LeadInsert> = {},
): Promise<Lead> {
  const { data, error } = await c
    .from('tf_leads')
    .update({ status, ...patch })
    .eq('id', id)
    .select('*')
    .single();
  if (error) throw error;
  return data;
}

export async function listLeads(c: TfClient, filter: LeadFilter = {}): Promise<Lead[]> {
  let q = c
    .from('tf_leads')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(filter.limit ?? 200);
  if (filter.toolId) q = q.eq('tool_id', filter.toolId);
  if (filter.status) q = q.eq('status', filter.status);
  if (filter.sessionId) q = q.eq('session_id', filter.sessionId);
  const { data, error } = await q;
  if (error) throw error;
  return data ?? [];
}

export async function getLead(c: TfClient, id: string): Promise<Lead | null> {
  const { data, error } = await c.from('tf_leads').select('*').eq('id', id).maybeSingle();
  if (error) throw error;
  return data;
}
